<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-center">
        <img src="../assets/autofit_logo_registered-1500h.png" alt="Logo" class="logo" />
        <ul class="navbar-links">
          <li><router-link to="/#home">Home</router-link></li>
          <li><router-link to="/features">{{$t('text00')}}</router-link></li>
          <li><router-link to="/pricing">{{$t('pricing')}}</router-link></li>
          <!-- More with animated dropdown -->
          <li class="more-menu" @click="toggleMore">
            <span>{{$t('more')}}</span>
            <span class="arrow" :class="{ open: showMore }"></span>
          </li>
        </ul>
      
        <div class="navbar-right navbar8-buttons1 navbar-buttons">
          <button class="thq-button-filled" @click="login">{{$t('trynow')}}</button>
          <button class="thq-button-outline thq-button-animated" @click="contact">{{$t('requestdemo')}}</button>
        </div>

        <!-- Language Selector -->
        <div class="language-selector" @click="toggleLanguageDropdown">
          <span class="current-language">{{ selectedLanguage }}</span>
          <span class="arrow" :class="{ open: showLanguageDropdown }"></span>

          <ul v-if="showLanguageDropdown" class="language-options">
            <li @click.stop="setLanguage('NL')">NL</li>
            <li @click.stop="setLanguage('FR')">FR</li>
            <li @click.stop="setLanguage('EN')">EN</li>
            <li @click.stop="setLanguage('DE')">DE</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Animated submenu across full width -->
    <transition name="slide-fade">
      <div v-if="showMore" class="fullwidth-submenu">
        <hr />
        <div class="submenu-content">
          <a href="https://mini.autofitsoftware.com">
            <div class="cssMenuMore">
              <img alt="Home Image" src="../assets/autofit_logo_anoukb-09-1400w.jpg" class="cssWH3030 thq-img-ratio-1-1">
              <div class="cssMenuMoreContent">
                <span class="cssFontStyleNormal thq-body-large">
                  <div class="cssContents">
                    <span class="cssInlineBlock">AutoFIT Mini</span>
                  </div>
                </span>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">Go To mini.autofitsoftware.com</span>
                  </div>
                </span>
              </div>
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=be.vlecad.autofitmini">
            <div class="cssMenuMore">
              <img alt="Features Image" src="../assets/download (1)-1400w.png" class="cssWH3030 thq-img-ratio-1-1">
              <div class="cssMenuMoreContent">
                <span class="cssFontStyleNormal thq-body-large">
                  <div class="cssContents">
                    <span class="cssInlineBlock">AutoFIT mini App</span>
                  </div>
                </span>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock"></span>
                  </div>
                </span>
              </div>
            </div>
          </a>
          <a href="https://vlecad.be/">
            <div class="cssMenuMore">
              <img alt="About Us Image" src="../assets/vlecad_logo_bruin_beeldmerk_steeds kleur-1400w.png" class="cssWH3030 thq-img-ratio-1-1">
              <div class="cssMenuMoreContent">
                <span class="cssFontStyleNormal thq-body-large">
                  <div class="cssContents">
                    <span class="cssInlineBlock">About Us</span>
                  </div>
                </span>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">Learn more about VLECAD®</span>
                  </div>
                </span>
              </div>
            </div>
          </a>
          <router-link to="/#contact">
            <div class="cssMenuMore">
              <svg height="48" width="48" viewBox="0 0 48 48">
                <g fill="currentColor">
                  <path fill-rule="evenodd" d="M24.8 33h2.7C34.404 33 40 27.404 40 20.5S34.404 8 27.5 8h-7C13.596 8 8 13.596 8 20.5c0 8.06 4.596 12.88 9.43 15.786c2.426 1.458 4.87 2.4 6.717 2.977q.341.107.653.197zm2 9s-.764-.129-2-.463C19.59 40.125 6 35.05 6 20.5C6 12.492 12.492 6 20.5 6h7C35.508 6 42 12.492 42 20.5S35.508 35 27.5 35h-.7z" clip-rule="evenodd"></path>
                  <path fill-rule="evenodd" d="M27.691 12.482c1.03.684 1.806 1.793 1.806 3.28c0 1.578-.636 2.738-1.667 3.448a4.5 4.5 0 0 1-1.33.614v1.532a1.5 1.5 0 0 1-3 0v-2.797a1.5 1.5 0 0 1 1.4-1.497c.554-.037.974-.147 1.227-.322a.7.7 0 0 0 .24-.272c.06-.12.13-.334.13-.707c0-.312-.122-.552-.467-.782c-.392-.26-1.022-.452-1.779-.476c-.748-.024-1.475.122-2.01.381c-.536.26-.733.552-.788.767a1.5 1.5 0 1 1-2.906-.746c.345-1.341 1.348-2.217 2.386-2.72c1.04-.505 2.263-.718 3.413-.681c1.143.036 2.363.324 3.345.978" clip-rule="evenodd"></path>
                  <path d="M27 27a2 2 0 1 1-4 0a2 2 0 0 1 4 0"></path>
                </g>
              </svg>
              <div class="cssMenuMoreContent">
                <span class="cssFontStyleNormal thq-body-large">
                  <div class="cssContents">
                    <span class="cssInlineBlock">Contact</span>
                  </div>
                </span>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">Get in touch with us</span>
                  </div>
                </span>
              </div>
            </div>
          </router-link>
        </div>
        <hr />
      </div>
    </transition>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      showMore: false,
      selectedLanguage: 'NL',
      showLanguageDropdown: false,
    }
  },
  methods: {
    login() {
      console.log("login");
      this.$router.push("/login");
    },
    contact() {
      console.log("contact2");
      this.$router.push("/contact");
    },
    toggleMore() {
      this.showMore = !this.showMore;
    },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    setLanguage(lang) {
      this.selectedLanguage = lang;
      this.showLanguageDropdown = false;
      this.$i18n.locale = lang.toLowerCase();
    },
  }
}
</script>


<style scoped>
.navbar {
  position: fixed;       /* of: sticky */
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: white; /* of jouw gewenste achtergrond */
  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* optioneel voor schaduw */
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-links {
  display: flex;
  list-style: none;
  gap: 20px;
}

.more-menu {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid #333;
  transition: transform 0.2s ease;
}

.arrow.open {
  transform: rotate(90deg); /* points down */
}

.fullwidth-submenu {
  width: 100%;
  background-color: white;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  animation: fadeDown 0.3s ease;
}

.submenu-content {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 15px 0;
}

.submenu-content a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 8px 16px;
}

hr {
  margin: 0;
  border: none;
  border-top: 1px solid #ccc;
}

/* Animation */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.slide-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.navbar-side {
  flex: 1;
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
}

.navbar-center {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  height: 80px;
}

.navbar-links li a {
  color: black;
  text-decoration: none;
}

.navbar-buttons {
  display: flex;
  gap: 1rem;
}

.language-selector {
  position: relative;
  cursor: pointer;
  margin-left: 20px;
  user-select: none;
}

.language-selector .current-language {
  font-weight: 500;
}

.language-selector .arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: transform 0.2s ease;
}

.language-selector .arrow.open {
  transform: rotate(180deg);
}

.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 5px 0;
  margin: 0;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  z-index: 999;
}

.language-options li {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
}

.language-options li:hover {
  background-color: #f0f0f0;
}

</style>
